// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ns-1";
export var messageSideRight = "_ns-2";
export var subscribeToBackInStockBubbleContainer = "_ns-0";